'use strict';
var SettingsEvents = /** @class */ (function () {
    function SettingsEvents() {
        'ngInject';
        this.practitionerSettingsEvents = {
            resetPasswordRequest: {
                event: 'resetPasswordRequest',
                practitionerId: '',
                platform: ''
            }
        };
    }
    return SettingsEvents;
}());
export { SettingsEvents };
//# sourceMappingURL=settings-events.js.map